import { graphql } from "react-relay";
// gql
import "../../team-search-input/TeamSearchInputRenderer.gql";
import "../../teams-settings/team-settings-search";
import "../../teams-settings/team-settings-admin-form/team-settings-admin-team-calendar";
import "../../teams-settings/team-settings-admin-form/team-settings-admin-slack";
import "../../teams-settings/team-settings-admin-form/team-settings-admin-no-meeting-day";

export const query = graphql`
  query WebSettingsTeamSettingsRelayQuery($orgRelayId: ID!, $teamId: String!) {
    viewer: viewer {
      ...TeamSettingsSearch_viewer @arguments(orgRelayId: $orgRelayId)
    }
    org: node(id: $orgRelayId) {
      ... on Org {
        ...TeamSearchInputRenderer_org
        ...TeamSettingsSearch_org
        ...TeamSettingsAdminTeamCalendar_org @arguments(teamId: $teamId)
        ...TeamSettingsAdminSlack_org @arguments(teamId: $teamId)
        ...TeamSettingsAdminNoMeetingDay_org @arguments(teamId: $teamId)
        id
        workingGroups(first: 1000000) {
          edges {
            node {
              calendarIds
            }
          }
        }
        primaryTeam {
          __typename
          ... on Team {
            teamId
            teamName
          }
          ... on GraphEntityError {
            statusCode
            message
          }
        }
        userTeams {
          __typename
          ... on TeamList {
            ...TeamPicker_userTeams
            list {
              ...TeamSettingsAdminTeamCalendar_team
              ...TeamSettingsSearch_team
              ...TeamSettingsAdminSlack_team
              ...TeamSettingsAdminNoMeetingDay_team
              teamId
              id
              teamId
              teamName
              createdBy {
                type
                value
              }
              teamCalendarId
              userSettings {
                __typename
                ... on TeamUserSettings {
                  useTeamCalendar
                }
              }
              teamMembers {
                role
                person {
                  userId
                  personId
                  primaryCalendarId
                  calendarAliases
                  isYou
                  redirectPersonId
                  profile {
                    givenName
                    familyName
                    externalImageUrl
                  }
                }
              }
              invitedMembers {
                role
                person {
                  userId
                  personId
                  primaryCalendarId
                  calendarAliases
                  isYou
                  redirectPersonId
                  profile {
                    givenName
                    familyName
                    externalImageUrl
                  }
                }
              }
            }
          }
          ... on GraphEntityError {
            statusCode
            message
          }
        }
        billingGroups {
          ... on BillingGroupList {
            list {
              id
              name
              syncSources {
                type
                value
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
  }
`;
